var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);

// node_modules/@mamdev/navigator.frontend-logger/dist/frontend-logger.mjs
function __spreadArray(to, from, pack) {
  if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
    if (ar || !(i in from)) {
      if (!ar) ar = Array.prototype.slice.call(from, 0, i);
      ar[i] = from[i];
    }
  }
  return to.concat(ar || Array.prototype.slice.call(from));
}
var logPrefixes = {
  debug: [],
  info: [],
  warn: [],
  error: []
};
function setLogPrefixes(customLogPrefixes) {
  if (customLogPrefixes instanceof Array) {
    logPrefixes.debug = customLogPrefixes;
    logPrefixes.info = customLogPrefixes;
    logPrefixes.warn = customLogPrefixes;
    logPrefixes.error = customLogPrefixes;
  } else {
    logPrefixes.debug = customLogPrefixes.debug || [];
    logPrefixes.info = customLogPrefixes.info || [];
    logPrefixes.warn = customLogPrefixes.warn || [];
    logPrefixes.error = customLogPrefixes.error || [];
  }
}
var consoleAppender = {
  debug: function() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
      args[_i] = arguments[_i];
    }
    console.debug.apply(console, __spreadArray(__spreadArray([], logPrefixes.debug, false), args, false));
  },
  info: function() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
      args[_i] = arguments[_i];
    }
    console.info.apply(console, __spreadArray(__spreadArray([], logPrefixes.info, false), args, false));
  },
  warn: function(message, error2, data) {
    console.warn.apply(console, __spreadArray(__spreadArray([], logPrefixes.warn, false), [message, error2, data], false));
  },
  error: function(message, error2, data) {
    console.error.apply(console, __spreadArray(__spreadArray([], logPrefixes.error, false), [message, error2, data], false));
  },
  setLogPrefixes
};
var LogLevel;
(function(LogLevel2) {
  LogLevel2[LogLevel2["debug"] = 0] = "debug";
  LogLevel2[LogLevel2["info"] = 1] = "info";
  LogLevel2[LogLevel2["warn"] = 2] = "warn";
  LogLevel2[LogLevel2["error"] = 3] = "error";
  LogLevel2[LogLevel2["none"] = 4] = "none";
})(LogLevel || (LogLevel = {}));
var appenders = [consoleAppender];
var _logLevel = LogLevel.debug;
function error(message, error2, data) {
  if (_logLevel <= LogLevel.error) {
    appenders.filter(function(appender) {
      return typeof appender.error === "function";
    }).forEach(function(appender) {
      appender.error(message, error2, data);
    });
  }
}

// src-client/config.ts
var EPI_SUBDOMAIN = "epimetheus";
var EPI_SUBDOMAIN_STAGE_SUFFIXES = {
  dev: "",
  qa: "-qa",
  prelive: "-pre",
  live: ""
};
var EPI_DOMAINS = {
  "1and1": "navigator.1und1.de",
  "1und1": "navigator.1und1.de",
  gmxat: "navigator.gmx.net",
  gmxch: "navigator.gmx.net",
  gmxcom: "navigator-bs.gmx.com",
  gmxcouk: "navigator-bs.gmx.co.uk",
  gmxes: "navigator-bs.gmx.es",
  gmxfr: "navigator-bs.gmx.fr",
  gmxnet: "navigator.gmx.net",
  mailcom: "navigator-lxa.mail.com",
  webde: "navigator.web.de"
};
var EPI_DOMAINS_DEV = {
  "1and1": "1and1.navigator.local.server.lan:8443",
  "1und1": "1and1.navigator.local.server.lan:8443",
  gmxat: "gmx.navigator.local.server.lan:8443",
  gmxch: "gmx.navigator.local.server.lan:8443",
  gmxcom: "gmxcom.navigator.local.server.lan:8443",
  gmxcouk: "gmxcom.navigator.local.server.lan:8443",
  gmxes: "gmxcom.navigator.local.server.lan:8443",
  gmxfr: "gmxcom.navigator.local.server.lan:8443",
  gmxnet: "gmx.navigator.local.server.lan:8443",
  mailcom: "mailcom.navigator.local.server.lan:8443",
  webde: "webde.navigator.local.server.lan:8443"
};
var EPI_ROUTE = "monitoring";

// src-client/util/service-url.ts
function getServiceUrl(brand, stage, clientRoute) {
  const stageSuffix = EPI_SUBDOMAIN_STAGE_SUFFIXES[stage] || "";
  const epiDomain = stage === "dev" ? EPI_DOMAINS_DEV[brand] : EPI_DOMAINS[brand];
  if (!epiDomain) {
    throw new Error(`No Epimetheus domain configured for brand ${brand}!`);
  }
  return `https://${EPI_SUBDOMAIN}${stageSuffix}.${epiDomain}/${EPI_ROUTE}/${clientRoute}`;
}

// src-client/service/monitoring.service.ts
var MonitoringService = class {
  constructor(options) {
    __publicField(this, "serviceUrl");
    __publicField(this, "data", {
      meta: {
        brand: null
      },
      counters: [],
      durations: []
    });
    options.brand = ["gmx", "gmxde"].includes(options.brand) ? "gmxnet" : options.brand;
    this.serviceUrl = getServiceUrl(options.brand, options.stage, options.client);
    this.data.meta = __spreadValues({
      brand: options.brand
    }, options.metaData);
    this.addListeners();
  }
  addListeners() {
    const callback = this.flush.bind(this);
    document.addEventListener("visibilitychange", callback, { capture: true });
    window.addEventListener("pagehide", callback, { capture: true });
    window.addEventListener("beforeunload", callback, { capture: true });
  }
  clearData() {
    this.data.counters = [];
    this.data.durations = [];
  }
  pushCounter(counter) {
    if (!(counter instanceof Array)) {
      counter = [counter];
    }
    this.data.counters.push(...counter);
  }
  pushDuration(duration) {
    if (!(duration instanceof Array)) {
      duration = [duration];
    }
    this.data.durations.push(...duration);
  }
  flush() {
    if (!navigator.sendBeacon || !this.hasData()) {
      return;
    }
    try {
      const queued = navigator.sendBeacon(this.serviceUrl, JSON.stringify(this.data));
      if (queued) {
        this.clearData();
      } else {
        error("Monitoring beacon was not queued!");
      }
    } catch (e) {
      error("Error while sending monitoring beacon", e);
    }
  }
  hasData() {
    return this.data.counters.length > 0 || this.data.durations.length > 0;
  }
};

// src-client/client/alligator/alligator-monitoring-service.ts
var AlligatorMonitoringService = class extends MonitoringService {
  constructor(options) {
    super(__spreadProps(__spreadValues({}, options), {
      client: "alligator"
    }));
  }
  monitorSharedLoginGrantSuccessful() {
    this.pushCounter({
      name: "event" /* event */,
      event: "shared_login_grant" /* shared_login_grant */,
      result: "success" /* success */
    });
  }
  monitorSharedLoginGrantFailed() {
    this.pushCounter({
      name: "event" /* event */,
      event: "shared_login_grant" /* shared_login_grant */,
      result: "failure" /* failure */
    });
  }
  monitorUserDataRequestSuccessful() {
    this.pushCounter({
      name: "event" /* event */,
      event: "user_data_request" /* user_data_request */,
      result: "success" /* success */
    });
  }
  monitorUserDataRequestFailed() {
    this.pushCounter({
      name: "event" /* event */,
      event: "user_data_request" /* user_data_request */,
      result: "failure" /* failure */
    });
  }
  monitorAccountDataRequestSuccessful() {
    this.pushCounter({
      name: "event" /* event */,
      event: "account_data_request" /* account_data_request */,
      result: "success" /* success */
    });
  }
  monitorAccountDataRequestFailed() {
    this.pushCounter({
      name: "event" /* event */,
      event: "account_data_request" /* account_data_request */,
      result: "failure" /* failure */
    });
  }
  monitorLogoutRequestSuccessful() {
    this.pushCounter({
      name: "event" /* event */,
      event: "logout_request" /* logout_request */,
      result: "success" /* success */
    });
  }
  monitorLogoutRequestFailed() {
    this.pushCounter({
      name: "event" /* event */,
      event: "logout_request" /* logout_request */,
      result: "failure" /* failure */
    });
  }
  monitorFirstAuthCodeGrantSuccessful() {
    this.pushCounter({
      name: "event" /* event */,
      event: "first_auth_code_grant" /* first_auth_code_grant */,
      result: "success" /* success */
    });
  }
  monitorFirstAuthCodeGrantFailed() {
    this.pushCounter({
      name: "event" /* event */,
      event: "first_auth_code_grant" /* first_auth_code_grant */,
      result: "failure" /* failure */
    });
  }
  monitorSecondAuthCodeGrantSuccessful() {
    this.pushCounter({
      name: "event" /* event */,
      event: "second_auth_code_grant" /* second_auth_code_grant */,
      result: "success" /* success */
    });
  }
  monitorSecondAuthCodeGrantFailed() {
    this.pushCounter({
      name: "event" /* event */,
      event: "second_auth_code_grant" /* second_auth_code_grant */,
      result: "failure" /* failure */
    });
  }
  monitorUserDataRequestDuration(startTime) {
    this.pushDuration({
      name: "user_data_request" /* user_data_request */,
      duration: Date.now() - startTime
    });
  }
  monitorAccountDataRequestDuration(startTime) {
    this.pushDuration({
      name: "account_data_request" /* account_data_request */,
      duration: Date.now() - startTime
    });
  }
  monitorLogoutRequestDuration(startTime) {
    this.pushDuration({
      name: "logout_request" /* logout_request */,
      duration: Date.now() - startTime
    });
  }
  monitorSharedLoginGrantDuration(startTime) {
    this.pushDuration({
      name: "shared_login_grant" /* shared_login_grant */,
      duration: Date.now() - startTime
    });
  }
  monitorFirstAuthCodeGrantDuration(startTime) {
    this.pushDuration({
      name: "first_auth_code_grant" /* first_auth_code_grant */,
      duration: Date.now() - startTime
    });
  }
  monitorSecondAuthCodeGrantDuration(startTime) {
    this.pushDuration({
      name: "second_auth_code_grant" /* second_auth_code_grant */,
      duration: Date.now() - startTime
    });
  }
};

// src-client/client/auth-intermediate/auth-intermediate-monitoring-service.ts
var AuthIntermediateMonitoringService = class extends MonitoringService {
  constructor(options) {
    super(__spreadProps(__spreadValues({}, options), {
      client: "authintermediate"
    }));
  }
  monitorLifecycleLoaded() {
    this.pushCounter({
      name: "app_lifecycle",
      event: "loaded"
    });
  }
  monitorTokenCreationSuccess(authMode) {
    this.pushCounter({
      name: "token_creation" /* token_creation */,
      event: "success" /* success */,
      mode: authMode
    });
  }
  monitorTokenCreationFailure(authMode) {
    this.pushCounter({
      name: "token_creation" /* token_creation */,
      event: "failure" /* failure */,
      mode: authMode
    });
  }
  monitorTrackFreeVerified(hasTrackFree) {
    this.pushCounter({
      name: "trackfree_verified",
      event: hasTrackFree ? "yes" : "no"
    });
  }
};

// src-client/client/feature-detection/feature-detection-monitoring-service.ts
var FeatureDetectionMonitoringService = class extends MonitoringService {
  constructor(options) {
    super(__spreadProps(__spreadValues({}, options), {
      client: "featuredetection"
    }));
  }
  monitorDetectionResult(result, device, loginType = "unknown") {
    this.pushCounter({
      name: "detection_result" /* detection_result */,
      event: result,
      device,
      login_type: loginType
    });
  }
};

// src-client/client/iac/iac-monitoring-service.ts
var IacMonitoringService = class extends MonitoringService {
  constructor(options) {
    super(__spreadProps(__spreadValues({}, options), {
      client: "iac"
    }));
  }
  monitorIacUseCaseReceived(usecase, sender, senderOrigin) {
    this.pushCounter({
      name: "usecase",
      event: "received",
      usecase,
      sender,
      sender_origin: senderOrigin,
      reason: "none"
    });
  }
  monitorIacUseCaseSent(usecase, sender, senderOrigin) {
    this.pushCounter({
      name: "usecase",
      event: "sent",
      usecase,
      sender,
      sender_origin: senderOrigin,
      reason: "none"
    });
  }
  monitorIacUseCaseInvalid(usecase, sender, reason, senderOrigin = "unknown") {
    this.pushCounter({
      name: "usecase",
      event: "invalid",
      usecase,
      sender,
      sender_origin: senderOrigin,
      reason
    });
  }
};

// src-client/client/ppp/ppp-monitoring-service.ts
var PppMonitoringService = class extends MonitoringService {
  constructor(options) {
    super(__spreadProps(__spreadValues({}, options), {
      client: "ppp"
    }));
  }
  monitorPppLifecycleStarted() {
    this.pushCounter({
      name: "lifecycle" /* lifecycle */,
      event: "started" /* started */
    });
  }
  monitorPppLifecycleEnded(success = true, reason = void 0) {
    const counter = {
      name: "lifecycle" /* lifecycle */,
      event: success ? "ended" /* ended */ : "aborted" /* aborted */
    };
    if (success === false && reason) {
      counter.reason = reason;
    }
    this.pushCounter(counter);
  }
  monitorPppCoreIframeLoadFailed() {
    this.pushCounter({
      name: "core_iframe_load" /* core_iframe_load */,
      event: "failed" /* failed */
    });
  }
  monitorPppCoreIframeLoadDuration(startTime) {
    this.pushDuration({
      name: "core_iframe_load" /* core_iframe_load */,
      duration: Date.now() - startTime
    });
  }
  monitorPppLayerIframeLoadDuration(startTime) {
    this.pushDuration({
      name: "adition_iframe_load" /* adition_iframe_load */,
      duration: Date.now() - startTime
    });
  }
  monitorPppLocalStorageReadFailed() {
    this.pushCounter({
      name: "local_storage" /* local_storage */,
      event: "read_failed" /* read_failed */
    });
  }
  monitorPppLocalStorageWriteFailed() {
    this.pushCounter({
      name: "local_storage" /* local_storage */,
      event: "write_failed" /* write_failed */
    });
  }
  monitorPppPermissionModelUpdate(usecase, status, success = true) {
    this.pushCounter({
      name: "permission_model_update" /* permission_model_update */,
      event: success ? "successful" /* successful */ : "failed" /* failed */,
      usecase,
      status
    });
  }
  monitorPppTcfUpdated(tcStatus, success = true) {
    this.pushCounter({
      name: "tcf_data_update" /* tcf_data_update */,
      event: success ? "successful" /* successful */ : "failed" /* failed */,
      tcStatus
    });
  }
  monitorPppLayerConnected() {
    this.pushCounter({
      name: "layer" /* layer */,
      event: "connected" /* connected */
    });
  }
  monitorPppLayerDisplayed() {
    this.pushCounter({
      name: "layer" /* layer */,
      event: "displayed" /* displayed */
    });
  }
  monitorPppLayerNextRequested() {
    this.pushCounter({
      name: "layer" /* layer */,
      event: "next_requested" /* next_requested */
    });
  }
  monitorPppLayerCompleted() {
    this.pushCounter({
      name: "layer" /* layer */,
      event: "completed" /* completed */
    });
  }
  monitorPppAditionIframeLoad() {
    this.pushCounter({
      name: "adition_iframe_load" /* adition_iframe_load */,
      event: "started" /* started */
    });
  }
  monitorPppAditionIframeLoadFailed() {
    this.pushCounter({
      name: "adition_iframe_load" /* adition_iframe_load */,
      event: "failed" /* failed */
    });
  }
  monitorPppEuconsentCookieUpdateFailed() {
    this.pushCounter({
      name: "tcf_cookie_euconsentv2_set" /* tcf_cookie_euconsentv2_set */,
      event: "failed" /* failed */
    });
  }
  monitorPppCookieTransferFailed() {
    this.pushCounter({
      name: "tcf_cookie_transfer" /* tcf_cookie_transfer */,
      event: "failed" /* failed */
    });
  }
  monitorPppTcfSyncStarted() {
    this.pushCounter({
      name: "tcf_sync" /* tcf_sync */,
      event: "started" /* started */
    });
  }
  monitorPppTcfSyncFailed() {
    this.pushCounter({
      name: "tcf_sync" /* tcf_sync */,
      event: "failed" /* failed */
    });
  }
  monitorPppPpsGetSent(identityType) {
    this.pushCounter({
      name: "pps_get_request" /* pps_get_request */,
      event: "sent" /* sent */,
      identityType
    });
  }
  monitorPppPpsGetFailed() {
    this.pushCounter({
      name: "pps_get_request" /* pps_get_request */,
      event: "failed" /* failed */
    });
  }
  monitorPppPpsPostSent(usecase, status, identityType) {
    this.pushCounter({
      name: "pps_post_request" /* pps_post_request */,
      event: "sent" /* sent */,
      identityType,
      usecase,
      status
    });
  }
  monitorPpsPostFailed(usecase, status, identityType) {
    this.pushCounter({
      name: "pps_post_request" /* pps_post_request */,
      event: "failed" /* failed */,
      identityType,
      usecase,
      status
    });
  }
};

// src-client/client/rtt/rtt-monitoring-service.ts
var RttMonitoringService = class extends MonitoringService {
  constructor(options) {
    super(__spreadProps(__spreadValues({}, options), {
      client: "rtt"
    }));
  }
  /**
   * RTT feature is active for this user session
   */
  monitorLifecycleActive() {
    this.pushCounter({
      name: "lifecycle" /* lifecycle */,
      event: "active" /* active */
    });
  }
  /**
   * Matching content has not yet been displayed to the user
   */
  monitorContentFresh() {
    this.pushCounter({
      name: "content" /* content */,
      event: "fresh" /* fresh */
    });
  }
  monitorProfileStoreRequestDuration(startTime) {
    this.pushDuration({
      name: "profile_store_request" /* profile_store_request */,
      duration: Date.now() - startTime
    });
  }
};

// src-client/client/spl/spl-monitoring-service.ts
var SplMonitoringService = class extends MonitoringService {
  constructor(options) {
    super(__spreadProps(__spreadValues({}, options), {
      client: "spl"
    }));
  }
  monitorLifecycleLoaded() {
    this.pushCounter({
      name: "lifecycle" /* lifecycle */,
      event: "loaded" /* loaded */
    });
  }
  monitorLifecycleConnected() {
    this.pushCounter({
      name: "lifecycle" /* lifecycle */,
      event: "connected" /* connected */
    });
  }
  monitorLifecycleDone() {
    this.pushCounter({
      name: "lifecycle" /* lifecycle */,
      event: "done" /* done */
    });
  }
  monitorTokenCreationSuccess(authMode) {
    this.pushCounter({
      name: "token_creation" /* token_creation */,
      event: "success" /* success */,
      mode: authMode
    });
  }
  monitorTokenCreationFailure(authMode) {
    this.pushCounter({
      name: "token_creation" /* token_creation */,
      event: "failure" /* failure */,
      mode: authMode
    });
  }
  monitorPpsWriteSuccess() {
    this.pushCounter({
      name: "pps_write" /* pps_write */,
      event: "success" /* success */,
      status: "2xx"
    });
  }
  monitorPpsWriteFailure(status) {
    this.pushCounter({
      name: "pps_write" /* pps_write */,
      event: "failure" /* failure */,
      status
    });
  }
};

// src-client/client/sse/sse-client-monitoring-service.ts
var SseClientMonitoringService = class extends MonitoringService {
  constructor(options) {
    super(__spreadProps(__spreadValues({}, options), {
      client: "sse"
    }));
  }
  monitorSseClientConnectionRequested() {
    this.pushCounter({
      name: "client_connection" /* client_connection */,
      event: "requested" /* requested */
    });
  }
  monitorSseClientConnectionOpened() {
    this.pushCounter({
      name: "client_connection" /* client_connection */,
      event: "opened" /* opened */
    });
  }
  monitorSseClientConnectionReopened() {
    this.pushCounter({
      name: "client_connection" /* client_connection */,
      event: "reopened" /* reopened */
    });
  }
  monitorSseClientConnectionError() {
    this.pushCounter({
      name: "client_connection" /* client_connection */,
      event: "error" /* error */
    });
  }
  monitorSseClientConnectionReopenError() {
    this.pushCounter({
      name: "client_connection" /* client_connection */,
      event: "reopen_error" /* reopen_error */
    });
  }
  monitorSseClientMessageReceived() {
    this.pushCounter({
      name: "client_connection" /* client_connection */,
      event: "message_received" /* message_received */
    });
  }
  monitorSseClientPodChanged() {
    this.pushCounter({
      name: "client_connection" /* client_connection */,
      event: "pod_changed" /* pod_changed */
    });
  }
  monitorSseClientConnectDuration(startTime) {
    this.pushDuration({
      name: "connect" /* connect */,
      duration: Date.now() - startTime
    });
  }
  monitorSseClientReconnectDuration(startTime) {
    this.pushDuration({
      name: "reconnect" /* reconnect */,
      duration: Date.now() - startTime
    });
  }
};

// src-client/client/upp/upp-monitoring-service.ts
var UppMonitoringService = class extends MonitoringService {
  constructor(options) {
    super(__spreadProps(__spreadValues({}, options), {
      client: "upp"
    }));
  }
  monitorUppLifecycleStarted(layerName = "", layerVariant = "") {
    this.pushCounter({
      name: "lifecycle" /* lifecycle */,
      event: "started" /* started */,
      reason: "none",
      layer_name: layerName,
      layer_variant: layerVariant
    });
  }
  monitorUppLifecycleAborted(reason, layerName = "", layerVariant = "") {
    this.pushCounter({
      name: "lifecycle" /* lifecycle */,
      event: "aborted" /* aborted */,
      reason,
      layer_name: layerName,
      layer_variant: layerVariant
    });
  }
  monitorUppLifecycleEnded(layerName = "", layerVariant = "") {
    this.pushCounter({
      name: "lifecycle" /* lifecycle */,
      event: "ended" /* ended */,
      reason: "none",
      layer_name: layerName,
      layer_variant: layerVariant
    });
  }
  monitorUppSmAdiRequestDuration(startTime) {
    this.pushDuration({
      name: "smadi_request" /* smadi_request */,
      duration: Date.now() - startTime
    });
  }
  monitorUppContentIframeLoadDuration(startTime) {
    this.pushDuration({
      name: "content_iframe_load" /* content_iframe_load */,
      duration: Date.now() - startTime
    });
  }
  monitorUppContentConnected(layerName, layerVariant) {
    this.pushCounter({
      name: "content" /* content */,
      event: "connected" /* connected */,
      layer_name: layerName || "",
      layer_variant: layerVariant || ""
    });
  }
  monitorUppContentNextCalled(layerName, layerVariant) {
    this.pushCounter({
      name: "content" /* content */,
      event: "next_called" /* next_called */,
      layer_name: layerName || "",
      layer_variant: layerVariant || ""
    });
  }
  monitorUppContentCompleteCalled(layerName, layerVariant) {
    this.pushCounter({
      name: "content" /* content */,
      event: "complete_called" /* complete_called */,
      layer_name: layerName || "",
      layer_variant: layerVariant || ""
    });
  }
};
export {
  AlligatorMonitoringService,
  AuthIntermediateMonitoringService,
  FeatureDetectionMonitoringService,
  IacMonitoringService,
  PppMonitoringService,
  RttMonitoringService,
  SplMonitoringService,
  SseClientMonitoringService,
  UppMonitoringService
};
//# sourceMappingURL=index.js.map
